__turbopack_context__.v({
  "ant-picker-cell": "BxVpMa_ant-picker-cell",
  "ant-picker-cell-in-view": "BxVpMa_ant-picker-cell-in-view",
  "ant-picker-date-panel": "BxVpMa_ant-picker-date-panel",
  "ant-picker-panel": "BxVpMa_ant-picker-panel",
  "bgModal": "BxVpMa_bgModal",
  "blankDay": "BxVpMa_blankDay",
  "btnPenjelasan": "BxVpMa_btnPenjelasan",
  "btnlogin": "BxVpMa_btnlogin",
  "buttonNextPrev": "BxVpMa_buttonNextPrev",
  "calendar": "BxVpMa_calendar",
  "calendarButton": "BxVpMa_calendarButton",
  "calendarContent": "BxVpMa_calendarContent",
  "calendarDate": "BxVpMa_calendarDate",
  "calendarTitle": "BxVpMa_calendarTitle",
  "card": "BxVpMa_card",
  "content": "BxVpMa_content",
  "dangerDay": "BxVpMa_dangerDay",
  "divTag": "BxVpMa_divTag",
  "firstButton": "BxVpMa_firstButton",
  "goodDay": "BxVpMa_goodDay",
  "netralDay": "BxVpMa_netralDay",
  "note": "BxVpMa_note",
  "noteDangerDay": "BxVpMa_noteDangerDay",
  "noteSafeDay": "BxVpMa_noteSafeDay",
  "noteToDay": "BxVpMa_noteToDay",
  "paragraph": "BxVpMa_paragraph",
  "paragraph2": "BxVpMa_paragraph2",
  "safeDay": "BxVpMa_safeDay",
  "safeDayB": "BxVpMa_safeDayB",
  "safeDayB2": "BxVpMa_safeDayB2",
  "safeDayG": "BxVpMa_safeDayG",
  "safeDayG2": "BxVpMa_safeDayG2",
  "secondButton": "BxVpMa_secondButton",
  "sosmed": "BxVpMa_sosmed",
  "sosmedAll": "BxVpMa_sosmedAll",
  "tag": "BxVpMa_tag",
  "title": "BxVpMa_title",
  "toDay": "BxVpMa_toDay",
  "toDay1": "BxVpMa_toDay1",
  "toDay2": "BxVpMa_toDay2",
  "toDay3": "BxVpMa_toDay3",
  "toDay4": "BxVpMa_toDay4",
  "toDay5": "BxVpMa_toDay5",
  "toDay6": "BxVpMa_toDay6",
  "width": "BxVpMa_width",
});
